export const FIRST_TAX_YEAR_WITHOUT_174 = 2025;
